module.exports = __webpack_public_path__ + "media/images/lane/take-coffee-087a0e7c18a828570931e03b2230b085.svg";